import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ansyn-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.less']
})
export class SettingsComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/settings/settings/settings.component.ts